/* eslint-disable react/no-array-index-key */
import React, { useEffect } from 'react'
import { useStoreState } from 'easy-peasy'
import styled from 'styled-components'
import Transition from './Transition'
import Landing from './Landing'
import Congrats from './Congrats'

const Container = styled.div`
  padding-bottom: 0;
`

export default function Main() {
  const [pages, showResults] = useStoreState(state => [
    state.steps.pages,
    state.quiz.showResults,
  ])

  useEffect(() => {
    if (showResults) {
      document.body.style.position = 'relative'
    }
  }, [showResults])

  return (
    <Container>
      {!showResults ? (
        <Landing>
          {pages.map(({ type }, index) => (
            <Transition
              key={`page-${index}`}
              step={index}
              type={type}
            />
          ))}
        </Landing>
      ) : (
        <Congrats />
      )}
    </Container>
  )
}
